import FeaturedCards from "@/components/FeaturedCards";
import SongCardDescription from "@/components/SongcardDescription";
import SubstackModal2 from "@/components/SubstackModal2";
import {
  Box,
  Center,
  Container,
  Divider,
  Grid,
  GridItem,
  Heading,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

enum PillState {
  FEATURED = "Featured",
  ABOUT = "About",
}

export default function Discover() {
  const { colorMode } = useColorMode();
  const [pillSelect, setPillSelect] = useState<PillState>(PillState.FEATURED);

  const paddingValue = 0;
  const letterSpacingValue = 5;

  return (
    <>
      <Head>
        <title>Songcards</title>
        <link rel="icon" href="/songcards.png" />
        <meta
          name="description"
          content="Discover a new format for digital music"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <link rel="canonical" href={`https://songcards.io/`} />
        <link rel="apple-touch-icon" href="/icon.png" />
        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta property="og:url" content="https://songcards.io/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Songcards" />
        <meta
          property="og:description"
          content="Discover a new format for digital music"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Songcards" />
        <meta
          name="twitter:description"
          content="Discover a new format for digital music"
        />
        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
        <meta name="msvalidate.01" content="CA08E3D312D9A033EADE0130E2FE2CC1" />
        <meta
          name="p:domain_verify"
          content="71fba16b731f3b706d15a11d5f730cca"
        />
      </Head>
      <>
        <Center p={paddingValue}>
          <Heading
            style={{ textTransform: "uppercase" }}
            as="h1"
            letterSpacing={letterSpacingValue}
            textAlign="center"
            maxW={700}
            mt={0}
            fontSize={48}
            lineHeight={1}
          >
            Listen.
          </Heading>
        </Center>
        <Center p={paddingValue}>
          <Heading
            style={{ textTransform: "uppercase" }}
            as="h1"
            letterSpacing={letterSpacingValue}
            textAlign="center"
            maxW={310}
            mt={0}
            fontSize={48}
            lineHeight={1}
          >
            Discover.
          </Heading>
        </Center>
        <Center p={paddingValue}>
          <Heading
            style={{ textTransform: "uppercase" }}
            as="h1"
            letterSpacing={letterSpacingValue}
            textAlign="center"
            maxW={300}
            bgGradient="linear(to-l, rgba(255,153,213,0.9), rgba(255,102,196,0.9))"
            bgClip="text"
            fontSize={48}
            lineHeight={1}
          >
            Collect.
          </Heading>
        </Center>
        <SubstackModal2 />
        {/* <JoinTheDiscord /> */}
        <Center mt={0} mb={0}>
          <a
            href="https://apps.apple.com/us/app/songcards/id6737206374?itscg=30200&itsct=apps_box_badge&mttnsubad=6737206374"
            style={{ display: "inlineBlock" }}
            target="_blank"
          >
            <Image
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1733443200"
              alt="Download on the App Store"
              width={300}
              height={300}
              style={{
                width: 123,
                height: 41,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.songcards.songcards&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          >
            <Image
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              width={300}
              height={300}
              style={{
                width: 155,
                height: 100,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
        </Center>
        <Center mt={2} mb={10}>
          <Divider maxW={400} />
        </Center>
        <Center>
          <Grid
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            gap={4}
            justifyContent="center"
          >
            <GridItem>
              <Box
                borderWidth={1}
                borderRadius={30}
                width={200}
                borderColor={colorMode === "light" ? "black" : "white"}
                borderStyle={
                  pillSelect == PillState.ABOUT ? "hidden" : "dotted"
                }
                padding={3}
                textAlign="center"
                onClick={() => setPillSelect(PillState.ABOUT)}
                backgroundColor={
                  pillSelect == PillState.ABOUT ? "rgba(255,153,213,0.9)" : ""
                }
                textColor={pillSelect == PillState.ABOUT ? "black" : ""}
                _hover={{ cursor: "pointer" }}
              >
                What is a Songcard?
              </Box>
            </GridItem>
            <GridItem>
              <Box
                borderWidth={1}
                borderRadius={30}
                width={200}
                borderColor={colorMode === "light" ? "black" : "white"}
                borderStyle={
                  pillSelect == PillState.FEATURED ? "hidden" : "dotted"
                }
                padding={3}
                textAlign="center"
                onClick={() => setPillSelect(PillState.FEATURED)}
                backgroundColor={
                  pillSelect == PillState.FEATURED
                    ? "rgba(255,153,213,0.9)"
                    : ""
                }
                textColor={pillSelect == PillState.FEATURED ? "black" : ""}
                _hover={{ cursor: "pointer" }}
              >
                Featured Songcards
              </Box>
            </GridItem>
          </Grid>
        </Center>
        {pillSelect == PillState.ABOUT && (
          <Center mb={0} padding={5}>
            <Center
              maxW="lg"
              alignItems="center"
              justifyContent="center"
              mt={10}
            >
              <SongCardDescription />
            </Center>
          </Center>
        )}
        {pillSelect == PillState.FEATURED && (
          <div>
            <br />
            <br />
            <br />
          </div>
        )}
        <Container maxWidth="2xl" mb={20}>
          <Center>
            <Heading size="lg" fontSize={30}>
              Discover Songcards
            </Heading>
          </Center>
          <br />
          <Center mb={5}>
            <Text>and grow your collection</Text>
          </Center>
          <FeaturedCards />
        </Container>
        <Center mb={300}>
          <Link href={`/`}>
            <Image
              src={
                colorMode === "dark"
                  ? "/SC Icon_B_White.svg"
                  : "/SC Icon_B_Black.svg"
              }
              width={30}
              height={30}
              alt="Discover more Songcards"
            />
          </Link>
        </Center>
      </>
    </>
  );
}
